import CustomTable from "@/components/CustomTable";
import {
  generalSetting,
  getGeneralSetting,
  getMerchantTeams,
  paymentConfig,
} from "@/services/Settings.service";
import {
  keepPreviousData,
  useInfiniteQuery,
  useMutation,
  useQuery,
} from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { columnsAsset, columnsT } from "./columns";
import { Button } from "@/components/ui/button";
import { IoFunnelOutline } from "react-icons/io5";
import { Input } from "@/components/ui/input";
import { ChevronLeft, UserPlus } from "lucide-react";
import Invite from "./common/Invite";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Link, useNavigate } from "react-router";
import { HiOutlineSlash } from "react-icons/hi2";
import CustomPageHeader from "../common/CustomPageHeader";
import CustomTabs from "@/components/CustomTabs";
import Profile from "./Profile";
import TeamManagement from "./TeamManagement";
import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";
import { useAuthState } from "@/context";
import { CustomModal } from "@/components/custom-modal";
import { InputOTP, InputOTPSlot } from "@/components/ui/input-otp";
import { Storage } from "@/services/storage-services";
import { ToastMessage, type } from "@/lib/toastr";

const AssetsManagement = () => {
  const { useCurrencies } = useAuthState();
  const currenciesList = useCurrencies()

  return (
    <div className="flex flex-col gap-8 p-6">
      <div>
        <Breadcrumb>
          <BreadcrumbList className="gap-2">
            <BreadcrumbItem>
              <Link
                to="/dashboard/settings"
                className="flex items-center gap-1 text-sm text-primary0"
              >
                <ChevronLeft className="w-3 h-3" />
                Settings
              </Link>
            </BreadcrumbItem>
            <BreadcrumbSeparator>
              <HiOutlineSlash />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbLink className="flex items-center gap-1 text-sm text-gray-60">
                Asset Management
              </BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      <CustomPageHeader
        title="Asset Management"
        description="Update essential business details and company information"
      />
      <div className="container mx-auto">
        <CustomTabs
          // pos="flex flex-row "  const { useCurrencies } = useAuthState();

          tabs={["Limits"]}
          tabData={{
            "Limits":
              <CustomTable
                data={currenciesList?.data?.data?.data || []}
                isLoading={currenciesList?.isLoading}
                columns={columnsAsset}
              />
            ,
          }}
        />
      </div>
    </div>
  );
};

export default AssetsManagement;

